import { useQuery } from '@tanstack/react-query';
import { fetchStpDemoApplications } from '@/api/SageAdmin/ClientAccount';
import { ReactQueryKey } from '@/constants/ReactQueryKeys';
import type { QueryParamsInterface } from '@/types/Shared';

export interface IApplicationList {
  name: string;
  email: string;
  title_id: string;
  active: string;
}

export const useSalesApplications = ({
  onSuccess,
  onError,
  params,
}: {
  onSuccess?: (data: any) => void;
  onError?: (err: any) => void;
  params?: QueryParamsInterface;
}) => {
  //Tanstack: version 5 query implementation
  return useQuery({
    queryKey: [ReactQueryKey.GET_ROLES, params],
    queryFn: () => fetchStpDemoApplications(params),
    onSuccess,
    onError,
    keepPreviousData: true,
    staleTime: 30000,
  });
};
